// extracted by mini-css-extract-plugin
export var pageBody = "Home-module--pageBody--1_sgT";